<template>
  <resource-create-wrapper
    :title="
      item
        ? $t('resources.favorites_blocks.duplicate_favorites_block')
        : $t('resources.favorites_blocks.new_favorites_block')
    "
    :need-modal="showModal"
    @saveAction="$refs['favoritesBlockForm'].submit()">
    <FavoritesBlockForm
      :favorites-block="item"
      @isDirtyForm="isDirtyForm"
      ref="favoritesBlockForm"></FavoritesBlockForm>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import FavoritesBlockForm from "@/components/forms/FavoritesBlockForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceCreateWrapper,
      FavoritesBlockForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
      },
      title: {
        type: String,
        required: true,
      },
      /**
       * Item is provided here when duplicating
       */
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
